import { TextDialogWithCircularProgress } from 'src/researcher/component/common';
import { TypeOfSliders, useIfSliderVisible } from './Slider';

export function Loader(props: { sliderId: TypeOfSliders }) {
  const open = useIfSliderVisible(props.sliderId);
  return <TextDialogWithCircularProgress message="Loading..." open={open} />;
}
